@for (col of columns; track col) {
  @if (tabletypeChecker.isDataColumn(col)) {
    @switch (col.dataType) {
      @case (DataColumnType.TEXT) {
        <td [ngClass]="col.class" [style]="col?.style">
          @if (col.truncate) {
            <p class="text-truncate" [style.max-width]="col.width" [attr.title]="rowData[col.field] || null"> {{rowData[col.field]}}</p>
          } @else {
            <p> {{rowData[col.field]}}</p>
          }
        </td>
      }
      @case (DataColumnType.DATE) {
        <td [ngClass]="col.class" [ngStyle]="col?.style" class="text-center">
          <p> {{rowData[col.field] | date: col?.format ?? defaultDateFormat}}</p>
        </td>
      }
      @case (DataColumnType.MONEY) {
        <td [ngClass]="col.class" class="text-right" [ngStyle]="col?.style">
          <p> {{ rowData[col.field] | currency:'COP':'symbol-narrow':'1.0-0' }}</p>
        </td>
      }
      @case (DataColumnType.CHECK) {
        <td CustomCheck [checked]="rowData[col.field]" class="text-center"></td>
      }
      @case (DataColumnType.NUMBER) {
        <td class="text-center" [ngStyle]="col?.style">
          <p> {{rowData[col.field]}}</p>
        </td>
      }   @case (DataColumnType.PERCENT) {
        <td class="text-center" [ngStyle]="col?.style">
          @if (isNaN(Number(rowData[col.field])) || rowData[col.field]?.toString().includes('%')) {
            <p> {{ rowData[col.field] }}
              <span>{{ (!rowData[col.field]?.toString().includes('%')) ? '%' : '' }}</span>
            </p>
          } @else {
            <p> {{ rowData[col.field] | percent :'1.0-1' }}</p>
          }
        </td>
      }
      @case (DataColumnType.CUSTOM) {
        <td [ngClass]="col.class" [ngStyle]="col?.style">
          <p> {{rowData[col.field] | excelFormat:col.format ?? ''}}</p>
        </td>
      }
      @case (DataColumnType.ESTADO_TAG) {
        <td>
          <p-tag [value]="rowData[col.field]"
                [icon]="getTramiteEstadoTagIcon(rowData[col.field], rowData['usuarioAsignadoCorreo'])"
                [severity]="getTramiteEstadoTagSeverity(rowData[col.field], rowData['usuarioAsignadoCorreo'])"></p-tag>
        </td>
      }
      @case (DataColumnType.TAG) {
        <td>
          <p-tag [style]="col.getStyle ? col.getStyle(rowData) : col?.style" [value]="rowData[col.field]">
          </p-tag>
        </td>     
      }
      @default {
        No Data Column
      }
    }
  } @else if (tabletypeChecker.isButtonColumn(col)) {
    <td [ngClass]="col.class"
      [pTooltip]="col.tooltip?.message ? col.tooltip?.message :'msg.btnDeshabilitado' | translate" [tooltipDisabled]="!col.disabled" tooltipPosition="top">
    @if (col.visible ? (rowData[col.visible.property] !== col.visible.value ) : true) {
      @switch (col.buttonType) {
        @case (ButtonColumnType.EDIT) {
            <CustomEditButton [item]="rowData" (onClick)="col.onClick($event.event, $event.item, col.field)"
              [disabled]="getDisabled(col)"/>
        }
        @case (ButtonColumnType.CUSTOM) {
          <button pButton [label]="col.label ?? ''" [icon]="col.icon ?? ''" (click)="col.onClick($event, rowData, col.field )"  [disabled]="getDisabled(col)"
            [class]=" col.class ?? 'p-button-outlined'" [severity]="getSeverity(col)"></button>
        }
        @case (ButtonColumnType.TEXT) {
          <button pButton [label]="col.truncate ? truncateLabel(rowData[col.field]) : rowData[col.field]" [icon]="col.icon ?? ''" (click)="col.onClick($event, rowData, col.field )"  [disabled]="getDisabled(col)"
            [class]=" col.class ?? 'p-button-outlined'" [attr.title]="col.truncate ? rowData[col.field] : null" [severity]="getSeverity(col)"></button>
        }
        @case (ButtonColumnType.DELETE) {
            <CustomDeleteButton [item]="rowData" (onClick)="col.onClick($event.event, $event.item, $event.field)"
              [disabled]="getDisabled(col)"/>
        }
        @case (ButtonColumnType.EXPANDED) {
            <button type="button" pButton [pRowToggler]="rowData" class="p-button-text p-button-rounded p-button-plain"
                    [ngClass]="col.class"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
          }
        @case (ButtonColumnType.CHECK) {
          <div class="flex align-items-center" ngClass="justify-content-center">
            <button pButton
              [icon]="rowData[col.field] ? 'pi pi-check-circle': 'pi pi-times-circle'"
              (click)="col.onClick($event, rowData, col.field)"
              [disabled]="col.disabled"
              severity="secondary"
              [class]=" col.class ?? 'p-button-outlined'"></button>
          </div>
        }
        @default {
          No Button Column
        }
      }
    }
    </td>
  } @else {
    No Type
  }
}
